const listViewButton = document.querySelector('.list-view-btn');
const gridViewButton = document.querySelector('.grid-view-btn');
const viewContainer = document.querySelector('.collections-resources-results_items');

if (viewContainer !== null && viewContainer !== undefined) {
    listViewButton.addEventListener('click', function() {
        viewContainer.classList.remove('collections-resources-results_items--grid-view');
        listViewButton.classList.add('active');
        gridViewButton.classList.remove('active');
    });


    gridViewButton.addEventListener('click', function() {
        viewContainer.classList.add('collections-resources-results_items--grid-view');
        listViewButton.classList.remove('active');
        gridViewButton.classList.add('active');
    });
}